import { defineComponent, openBlock, createElementBlock, createElementVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "Document"
});
const _hoisted_1 = {
  class: "icon",
  width: "200px",
  height: "200.00px",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  d: "M832 384h-256V128H192v768h640V384z m-25.984-64L640 153.984V320h166.016zM160 64h480l256 256v608q0 14.016-8.992 23.008T864 960H160q-14.016 0-23.008-8.992T128 928V96q0-14.016 8.992-23.008T160 64z m160 448h384v64H320v-64z m0-192h160v64h-160v-64z m0 384h384v64H320v-64z",
  fill: "currentColor"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_3);
}
var document = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "E:\\gitlab\\sgui-plus-icon\\packages\\vue\\src\\document.vue"]]);

export { document as default };
